import { render, staticRenderFns } from "./View-Allocation-Detail.vue?vue&type=template&id=243fac21&scoped=true"
import script from "./View-Allocation-Detail.vue?vue&type=script&lang=js"
export * from "./View-Allocation-Detail.vue?vue&type=script&lang=js"
import style0 from "./View-Allocation-Detail.vue?vue&type=style&index=0&id=243fac21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243fac21",
  null
  
)

export default component.exports